export default __webpack_public_path__ + "static/media/Temp.51eddeb4.mp4";